module.exports = __webpack_public_path__ + "img/7.49822612.jpg";